export default __webpack_public_path__ + "static/media/caret-down.6999d072.svg";